// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "call_window_limit_date.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "call_window_limit_date.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class CallWindowLimitDate$Type extends MessageType {
    constructor() {
        super("CallWindowLimitDate", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "call_window_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "override_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "window_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "maint_max", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.callWindowId = 0;
        message.overrideDate = "";
        message.windowCount = 0;
        message.maintMax = 0;
        message.createdAt = "";
        message.updatedAt = "";
        message.isActive = false;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 call_window_id */ 2:
                    message.callWindowId = reader.int32();
                    break;
                case /* string override_date */ 3:
                    message.overrideDate = reader.string();
                    break;
                case /* int32 window_count */ 4:
                    message.windowCount = reader.int32();
                    break;
                case /* int32 maint_max */ 5:
                    message.maintMax = reader.int32();
                    break;
                case /* string created_at */ 6:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 7:
                    message.updatedAt = reader.string();
                    break;
                case /* bool is_active */ 8:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 9:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 10:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 11:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 12:
                    message.orderDir = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 call_window_id = 2; */
        if (message.callWindowId !== 0)
            writer.tag(2, WireType.Varint).int32(message.callWindowId);
        /* string override_date = 3; */
        if (message.overrideDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.overrideDate);
        /* int32 window_count = 4; */
        if (message.windowCount !== 0)
            writer.tag(4, WireType.Varint).int32(message.windowCount);
        /* int32 maint_max = 5; */
        if (message.maintMax !== 0)
            writer.tag(5, WireType.Varint).int32(message.maintMax);
        /* string created_at = 6; */
        if (message.createdAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 7; */
        if (message.updatedAt !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.updatedAt);
        /* bool is_active = 8; */
        if (message.isActive !== false)
            writer.tag(8, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 9; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 10; */
        if (message.pageNumber !== 0)
            writer.tag(10, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 11; */
        if (message.orderBy !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 12; */
        if (message.orderDir !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderDir);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CallWindowLimitDate
 */
export const CallWindowLimitDate = new CallWindowLimitDate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallWindowLimitDateList$Type extends MessageType {
    constructor() {
        super("CallWindowLimitDateList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CallWindowLimitDate },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated CallWindowLimitDate results */ 1:
                    message.results.push(CallWindowLimitDate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated CallWindowLimitDate results = 1; */
        for (let i = 0; i < message.results.length; i++)
            CallWindowLimitDate.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CallWindowLimitDateList
 */
export const CallWindowLimitDateList = new CallWindowLimitDateList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallWindowLimitDateRangeRequest$Type extends MessageType {
    constructor() {
        super("CallWindowLimitDateRangeRequest", [
            { no: 1, name: "date_start", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "date_end", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "event_trade_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dateStart = "";
        message.dateEnd = "";
        message.departmentId = 0;
        message.eventTradeId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string date_start */ 1:
                    message.dateStart = reader.string();
                    break;
                case /* string date_end */ 2:
                    message.dateEnd = reader.string();
                    break;
                case /* int32 department_id */ 3:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 event_trade_id */ 4:
                    message.eventTradeId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string date_start = 1; */
        if (message.dateStart !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.dateStart);
        /* string date_end = 2; */
        if (message.dateEnd !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dateEnd);
        /* int32 department_id = 3; */
        if (message.departmentId !== 0)
            writer.tag(3, WireType.Varint).int32(message.departmentId);
        /* int32 event_trade_id = 4; */
        if (message.eventTradeId !== 0)
            writer.tag(4, WireType.Varint).int32(message.eventTradeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CallWindowLimitDateRangeRequest
 */
export const CallWindowLimitDateRangeRequest = new CallWindowLimitDateRangeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallWindowLimitDateEntry$Type extends MessageType {
    constructor() {
        super("CallWindowLimitDateEntry", [
            { no: 1, name: "call_window_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "override_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "window_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "maint_max", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.callWindowId = 0;
        message.overrideDate = "";
        message.windowCount = 0;
        message.maintMax = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 call_window_id */ 1:
                    message.callWindowId = reader.int32();
                    break;
                case /* string override_date */ 2:
                    message.overrideDate = reader.string();
                    break;
                case /* int32 window_count */ 3:
                    message.windowCount = reader.int32();
                    break;
                case /* int32 maint_max */ 4:
                    message.maintMax = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 call_window_id = 1; */
        if (message.callWindowId !== 0)
            writer.tag(1, WireType.Varint).int32(message.callWindowId);
        /* string override_date = 2; */
        if (message.overrideDate !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.overrideDate);
        /* int32 window_count = 3; */
        if (message.windowCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.windowCount);
        /* int32 maint_max = 4; */
        if (message.maintMax !== 0)
            writer.tag(4, WireType.Varint).int32(message.maintMax);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CallWindowLimitDateEntry
 */
export const CallWindowLimitDateEntry = new CallWindowLimitDateEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallWindowLimitDateBulkRequest$Type extends MessageType {
    constructor() {
        super("CallWindowLimitDateBulkRequest", [
            { no: 1, name: "entries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CallWindowLimitDateEntry }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.entries = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated CallWindowLimitDateEntry entries */ 1:
                    message.entries.push(CallWindowLimitDateEntry.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated CallWindowLimitDateEntry entries = 1; */
        for (let i = 0; i < message.entries.length; i++)
            CallWindowLimitDateEntry.internalBinaryWrite(message.entries[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CallWindowLimitDateBulkRequest
 */
export const CallWindowLimitDateBulkRequest = new CallWindowLimitDateBulkRequest$Type();
/**
 * @generated ServiceType for protobuf service CallWindowLimitDateService
 */
export const CallWindowLimitDateService = new ServiceType("CallWindowLimitDateService", [
    { name: "CreateCallWindowLimitDate", options: {}, I: CallWindowLimitDate, O: CallWindowLimitDate },
    { name: "GetCallWindowLimitDate", options: {}, I: CallWindowLimitDate, O: CallWindowLimitDate },
    { name: "BatchGetCallWindowLimitDate", options: {}, I: CallWindowLimitDate, O: CallWindowLimitDateList },
    { name: "UpdateCallWindowLimitDate", options: {}, I: CallWindowLimitDate, O: CallWindowLimitDate },
    { name: "DeleteCallWindowLimitDate", options: {}, I: CallWindowLimitDate, O: Empty },
    { name: "BatchGetCallWindowLimitDateRange", options: {}, I: CallWindowLimitDateRangeRequest, O: CallWindowLimitDateList },
    { name: "BulkUpsertCallWindowLimitDate", options: {}, I: CallWindowLimitDateBulkRequest, O: CallWindowLimitDateList },
    { name: "BulkDeleteCallWindowLimitDate", options: {}, I: CallWindowLimitDateBulkRequest, O: Empty }
]);
